export default __webpack_public_path__ + "static/media/d93ba969e3addd2217c1fb32e528f24a.jpg";